export default function getResource(label, vars = []) {
    const resources = {
        optinCreateHeading: 'Skip your password next time for a faster and more secure sign in',
        subheading: 'Use the same face or fingerprint you use to unlock your device. We never receive your biometric data like fingerprints or face scans.',
        warningNotification: 'Not advised for shared devices.',
        termsAndConditions: 'By clicking "Continue", you (1) agree to the current version of our ',
        termsOfUse: 'TERMS OF USE',
        termsAndConditionsRest: ', and (2) have read Sephora\'s ',
        privacyPolicy: 'Privacy Policy',
        whatIsPasskey: 'What is a passkey?',
        setupButton: 'Continue',
        maybeLaterButton: 'Maybe Later',
        laterButton: 'Later',
        passkeyErrorTitle: 'Error',
        passkeyErrorMessage: 'We couldn’t set up your passkey right now. Please try again.',
        passkeyErrorButton: 'OK',
        passkeyExpiredLinkMessage: 'Your link for creating a passkey has expired.<br><br>Please hit resend to get a new passkey email. If you are unable to create a passkey from the email try using another device or reset your password instead. If unable to reset password you can contact Customer service at 1-877-SEPHORA(1-877—377-4672) for assistance',
        passkeyUnsupportedDeviceMessage: 'Your device is not eligible for passkey creation.',
        createNewPasskey: 'Create New Passkey',
        cancel: 'Cancel',
        passkeyCreated: 'Passkey created!',
        optinCreateAccountHeading: 'Create a new passkey'
    };

    return resources[label];
}
